"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerRadius = exports.StyledIndividualCorner = exports.StyledCornerContent = exports.StyledCornerContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const Slider_1 = require("../../components/Slider");
exports.StyledCornerContainer = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledCornerContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
`;
exports.StyledIndividualCorner = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
`;
function CornerRadius({ onUpdate, radius, icon, title, variant, buttonVariant, maxValue, minValue, value: initialValue, }) {
    const [value, setValue] = (0, react_1.useState)({
        radius,
    });
    const handleCorner = (0, react_1.useCallback)((data) => {
        setValue(Object.assign(Object.assign({}, value), data));
        onUpdate(data);
    }, [onUpdate, value]);
    return ((0, jsx_runtime_1.jsx)(Slider_1.Slider, { title: title, maxValue: maxValue, minValue: minValue, value: initialValue, onUpdate: handleCorner, variant: "default", id: "title", icon: icon }));
}
exports.CornerRadius = CornerRadius;
//# sourceMappingURL=CornerRadius.js.map